import type { StyleLayer } from './utils/types'

export const layers_bikelanes_plus_routes: StyleLayer[] = [
  {
    id: 'route',
    type: 'line',
    layout: {
      'line-join': 'round',
    },
    paint: {
      'line-blur': 1,
      'line-color': [
        'case',
        ['match', ['get', 'network'], ['lcn'], true, false],
        'rgba(51, 186, 240, 0.54)',
        ['match', ['get', 'network'], ['ncn', 'icn'], true, false],
        'rgba(51, 240, 92, 0.85)',
        ['match', ['get', 'network'], ['rcn'], true, false],
        'rgba(51, 117, 240, 0.54)',
        '#858585',
      ],
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        5,
        ['match', ['get', 'network'], ['ncn', 'icn'], 0.9, 0],
        8,
        [
          'match',
          ['get', 'network'],
          ['ncn', 'icn'],
          0.9,
          ['match', ['get', 'network'], ['rcn'], 0.8, 0],
        ],
        8.5,
        ['match', ['get', 'network'], ['ncn', 'icn', 'rcn'], 0.8, 0],
        9,
        ['match', ['get', 'network'], ['ncn', 'icn', 'rcn', 'lcn'], 0.8, 0],
        10,
        0.4,
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 5, 2, 8, 3, 18, 20],
    },
  },
  {
    id: 'RSV',
    type: 'line',
    filter: ['match', ['get', 'cycle_highway'], ['yes'], true, false],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-blur': 1,
      'line-color': '#fabd05',
      'line-opacity': ['interpolate', ['linear'], ['zoom'], 5, 1, 12, 0.4],
      'line-width': ['interpolate', ['linear'], ['zoom'], 5, 4, 8, 5, 18, 25],
    },
  },
  {
    id: 'sign_label',
    type: 'symbol',
    filter: ['has', 'ref'],
    layout: {
      'icon-image': [
        'match',
        ['get', 'network'],
        ['ncn'],
        'label-box-green',
        ['icn', 'rcn'],
        'label-box-blue',
        '',
      ],
      'icon-padding': 6,
      'icon-size': 1.5,
      'symbol-placement': 'line',
      'symbol-spacing': 700,
      'text-field': ['to-string', ['get', 'ref']],
      'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
      'text-letter-spacing': -0.02,
      'text-size': 10,
      'text-transform': 'uppercase',
    },
    paint: {
      'icon-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        5,
        ['match', ['get', 'network'], ['ncn', 'icn'], 1, 0],
        9.4,
        ['match', ['get', 'network'], ['ncn', 'icn'], 1, 0],
        9.5,
        1,
      ],
      'text-color': '#c7efff',
      'text-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        5,
        ['match', ['get', 'network'], ['ncn', 'icn'], 1, 0],
        9.4,
        ['match', ['get', 'network'], ['ncn', 'icn'], 1, 0],
        9.5,
        1,
      ],
    },
  },
]
